























































// Copyright (c) 2021 by Move Closer

import { defineComponent } from '@vue/composition-api'

import { moduleProps, useModule } from './Module.hooks'
import { ModuleResizeAxis } from './Module.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const AbstractModule = defineComponent({
  name: 'AbstractModule',
  props: moduleProps,
  setup: useModule,
  computed: {
    resolveInnerComponent () {
      throw new Error('AbstractModule: Missing implementation of [resolveInnerComponent] computed.')
    }
  },
  methods: {
    scale (step: number, axis: ModuleResizeAxis) {
      this.resize(step, axis)
    }
  }
})

export default AbstractModule
